import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("line", {
  x1: "12",
  y1: "20",
  x2: "12",
  y2: "10"
}), ___EmotionJSX("line", {
  x1: "18",
  y1: "20",
  x2: "18",
  y2: "4"
}), ___EmotionJSX("line", {
  x1: "6",
  y1: "20",
  x2: "6",
  y2: "16"
}));
export default SVG;